import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { FaDownload, FaPrint } from 'react-icons/fa';

const Invoice = ({ order, items, customerDetails, company, onPrint, showActions = true }) => {
  // Default company details
  const defaultCompany = {
    name: 'Telering Process Pvt. Ltd',
    address: '123 Commerce Street',
    city: 'Business City, ST 12345',
    phone: '(555) 987-6543',
    email: 'support@officesetup.com'
  };

  // Use provided company details or defaults
  const companyInfo = company || defaultCompany;

  // Calculate totals
  const subtotal = order.total ||
    items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const taxRate = 0.08; // 8%
  const taxAmount = subtotal * taxRate;
  const shippingCost = 10.00;
  const total = subtotal + taxAmount + shippingCost;

  // Handle print function
  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      // Default print functionality
      const printWindow = window.open('', '_blank');

      const invoiceContent = document.getElementById('invoice-content').innerHTML;

      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice #${order.id}</title>
            <link 
              href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" 
              rel="stylesheet" 
              integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" 
              crossorigin="anonymous"
            >
            <style>
              body { padding: 20px; }
              .invoice-header { margin-bottom: 30px; }
              @media print {
                .no-print { display: none !important; }
                body { padding: 0; }
                .container { width: 100%; max-width: 100%; }
              }
            </style>
          </head>
          <body>
            <div class="container">
              ${invoiceContent}
            </div>
            <script>
              window.onload = function() { window.print(); }
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();
    }
  };

  return (
    <div>
      <div id="invoice-content">
        <div className="row mb-4">
          <div className="col-6">
            <h4 className="mb-3">{companyInfo.name}</h4>
            <p className="mb-1">{companyInfo.address}</p>
            <p className="mb-1">{companyInfo.city}</p>
            <p className="mb-1">Phone: {companyInfo.phone}</p>
            <p>Email: {companyInfo.email}</p>
          </div>
          <div className="col-6 text-end">
            <h4 className="mb-3">Invoice #{order.id}</h4>
            <p className="mb-1"><strong>Date:</strong> {order.date}</p>
            <p className="mb-1"><strong>Status:</strong> {order.status?.toUpperCase()}</p>
            <p><strong>Order ID:</strong> #{order.id}</p>
          </div>
        </div>

        {customerDetails && (
          <div className="row mb-4">
            <div className="col-6">
              <h5>Bill To:</h5>
              <p className="mb-1">{customerDetails.name || order.customer}</p>
              <p className="mb-1">{customerDetails.address}</p>
              <p className="mb-1">Email: {customerDetails.email}</p>
              <p>Phone: {customerDetails.phone}</p>
            </div>
            <div className="col-6">
              <h5>Ship To:</h5>
              <p className="mb-1">{customerDetails.name || order.customer}</p>
              <p>{customerDetails.address}</p>
            </div>
          </div>
        )}

        <Table bordered className="mb-4">
          <thead className="bg-light">
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Quantity</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.name}</td>
                <td>₹{(typeof item.price === 'number' ? item.price : parseFloat(item.price || 0)).toFixed(2)}</td>
                <td>{item.quantity}</td>
                <td className="text-end">₹{((typeof item.price === 'number' ? item.price : parseFloat(item.price || 0)) * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="3" className="text-end"><strong>Subtotal</strong></td>
              <td className="text-end">₹{(typeof subtotal === 'number' ? subtotal : parseFloat(subtotal || 0)).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3" className="text-end"><strong>Tax ({(taxRate * 100).toFixed(0)}%)</strong></td>
              <td className="text-end">₹{(typeof taxAmount === 'number' ? taxAmount : parseFloat(taxAmount || 0)).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3" className="text-end"><strong>Shipping</strong></td>
              <td className="text-end">₹{(typeof shippingCost === 'number' ? shippingCost : parseFloat(shippingCost || 0)).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3" className="text-end"><strong>Total</strong></td>
              <td className="text-end"><strong>₹{(typeof total === 'number' ? total : parseFloat(total || 0)).toFixed(2)}</strong></td>
            </tr>
          </tfoot>
        </Table>

        <div className="row">
          <div className="col-12">
            <h5>Notes:</h5>
            <p>Thank you for your business! If you have any questions about this invoice, please contact our customer support.</p>
          </div>
        </div>
      </div>

      {showActions && (
        <div className="d-flex justify-content-end mt-4 no-print">
          <Button
            variant="primary"
            onClick={handlePrint}
            className="d-flex align-items-center"
          >
            <FaDownload className="me-2" /> Download / Print
          </Button>
        </div>
      )}
    </div>
  );
};

export default Invoice; 